export const money = new Intl.NumberFormat('en-US', { style: 'decimal', maximumFractionDigits: 2 });
